// extracted by mini-css-extract-plugin
export var notificationHost = "_ee-0";